import { addresses } from "src/constants";
import { connectToChainId } from "src/helpers/envHelper";
import apollo from "../../lib/apolloClient";

// TODO: add paramaterization
export const treasuryDataQuery = `
query {
  protocolMetrics(first: 100, orderBy: timestamp, orderDirection: desc) {
    id
    timestamp
    gwsCirculatingSupply
    sGwsCirculatingSupply
    totalSupply
    gwsPrice
    marketCap
    totalValueLocked
    treasuryRiskFreeValue
    treasuryMarketValue
    nextEpochRebase
    nextDistributedGws
    treasuryDaiRiskFreeValue
    treasuryDaiMarketValue
    currentAPY
    runway10k
    runway20k
    runway50k
    runwayCurrent
    holders
    treasuryGwsDaiPOL
  }
}
`;

export const rebasesDataQuery = `
query {
  rebases(where: {contract: "${addresses[connectToChainId].STAKING_ADDRESS}"}, orderBy: timestamp, first: 1000, orderDirection: desc) {
    percentage
    timestamp
  }
}
`;

export const treasuryData = () => apollo(treasuryDataQuery).then(r => r.data.protocolMetrics);

// export default treasuryData;
export const bulletpoints = (coinColors, stakedColors, polColors, apiColor, runwayColors) => {
  const setCoin = () => {
    let colors = [
      {
        right: 15,
        top: -12,
        background: "linear-gradient(180deg, #F5AC37 -10%, #EA9276 100%)",
      },
      {
        right: 25,
        top: -12,
        background: "linear-gradient(180deg, #768299 -10%, #98B3E9 100%)",
      },
      {
        right: 29,
        top: -12,
        background: "linear-gradient(180deg, #DC30EB -10%, #EA98F1 100%)",
      },
      {
        right: 29,
        top: -12,
        background: "linear-gradient(180deg, #4C8C2A -10%, #8BFF4D 100%)",
      },
    ];

    if (coinColors) {
      colors = [
        {
          right: 15,
          top: -12,
          background: coinColors[0],
        },
        {
          right: 25,
          top: -12,
          background: coinColors[1],
        },
        {
          right: 29,
          top: -12,
          background: coinColors[2],
        },
        {
          right: 29,
          top: -12,
          background: coinColors[3],
        },
      ];
    }
    return colors;
  }

  const setStakedColors = () => {
    let staked = [
      {
        right: 45,
        top: -11,
        background: "linear-gradient(180deg, #55EBC7 -10%, rgba(71, 172, 235, 0) 100%)",
      },
      {
        right: 68,
        top: -12,
        background: "rgba(151, 196, 224, 0.2)",
        border: "1px solid rgba(54, 56, 64, 0.5)",
      },
    ];

    if (stakedColors) {
      staked = [
        {
          right: 45,
          top: -11,
          background: stakedColors[0]
        },
        {
          right: 68,
          top: -12,
          background: stakedColors[1]
        },
      ]
    }

    return staked;
  }

  const setPol = () => {
    let pol = [
      {
        right: 15,
        top: -12,
        background: "linear-gradient(180deg, rgba(56, 223, 63, 1) -10%, rgba(182, 233, 152, 1) 100%)"
      },
      {
        right: 25,
        top: -12,
        background: "rgba(219, 242, 170, 1)"
      },
    ]

    if (polColors) {
      pol = [
        {
          right: 15,
          top: -12,
          background: polColors[0],
        },
        {
          right: 25,
          top: -12,
          background: polColors[1],
        },
      ]
    }

    return pol;
  }

  const setRunwayColors = () => {
    let runway = [
      {
        right: 45,
        top: -12,
        background: "#FFFFFF",
      },
      {
        right: 48,
        top: -12,
        background: "#2EC608",
      },
      {
        right: 48,
        top: -12,
        background: "#49A1F2",
      },
    ]

    if (runwayColors) {
      runway = [
        {
          right: 45,
          top: -12,
          background: runwayColors[0],
        },
        {
          right: 48,
          top: -12,
          background: runwayColors[1],
        },
        {
          right: 48,
          top: -12,
          background: runwayColors[2],
        },
      ]
    }

    return runway;
  }

  return {
    tvl: [
      {
        right: 20,
        top: -12,
        background: "linear-gradient(180deg, #768299 -10%, #98B3E9 100%)",
      },
    ],
    coin: setCoin(),
    holder: [
      {
        right: 40,
        top: -12,
        background: "#A3A3A3",
      },
    ],
    apy: [
      {
        right: 20,
        top: -12,
        background: apiColor ? apiColor : "#49A1F2",
      },
    ],
    runway: setRunwayColors(),
    staked: setStakedColors(),
    pol: setPol(),
  };
}

export const tooltipItems = {
  tvl: ["TVL"],
  coin: ["DAI"],
  holder: ["GWSies"],
  apy: ["APY"],
  runway: ["Days"],
  pol: ["SLP Treasury", "Market SLP"],
};

export const tooltipInfoMessages = {
  tvl: "Total Value Deposited, is the dollar amount of all GWS staked in the protocol. This metric is often used as growth or health indicator in DeFi projects.",
  mvt: "Market Value of Treasury Assets, is the sum of the value (in dollars) of all assets held by the treasury.",
  rfv: "Risk Free Value, is the amount of funds the treasury guarantees to use for backing GWS.",
  pol: "Protocol Owned Liquidity, is the amount of LP the treasury owns and controls. The more POL the better for the protocol and its users.",
  holder: "Holders, represents the total number of Gwsies (sGWS holders)",
  staked: "GWS Staked, is the ratio of sGWS to GWS (staked vs unstaked)",
  apy: "Annual Percentage Yield, is the normalized representation of an interest rate, based on a compounding period over one year. Note that APYs provided are rather ballpark level indicators and not so much precise future results.",
  runway: "Runway, is the number of days sGWS emissions can be sustained at a given rate. Lower APY = longer runway",
};

export const itemType = {
  dollar: "$",
  percentage: "%",
};
